import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './Endodontics.css';

const Endodontics = () => {
    const pricing = [
        { type: "Mono Rooted Tooth (Anterior)", price: "₱9,000" },
        { type: "Multi Rooted", price: "$₱,000 UP" },
        { type: "Post and Core Build-up (Fiber Post)", price: "$₱,000" },
    
    ];

    return (
        <>
        <Header/>
        <div className="endodontics-container">
            <Header />
            <div className="endodontics-content">
                <h1>ENDODONTICS</h1>
                <p>
                Endodontics is a dental specialty focused on treating the inside of a tooth, specifically the pulp. 
                The most common endodontic procedure is a root canal, which involves removing infected or damaged pulp 
                and sealing the tooth to prevent reinfection. Endodontists also perform other procedures like retreatment 
                (redoing a previous root canal), apicoectomy (surgery to remove the infected tip of a root), and trauma treatment. 
                The goal of endodontic treatment is to save a tooth and prevent extraction.
                </p>
                <h2>Pricing</h2>
                <table className="endodontics-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};

export default Endodontics;